import * as React from "react"
import {
  Button,
  ButtonGroup,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverProps,
  PopoverTrigger,
  Portal,
  Text,
} from "@chakra-ui/react"

export interface Props extends PopoverProps {
  onSubmit?: () => void
  title?: string
  text?: string
  submitText?: string
  submitColor?: string
  isLoading?: boolean
  children: React.ReactNode
}

export const Confirmation: React.FC<Props> = (props) => {
  return (
    <Popover placement="bottom" {...props}>
      {({ onClose }) => (
        <>
          <PopoverTrigger>{props.children}</PopoverTrigger>
          <Portal>
            <PopoverContent>
              <PopoverHeader fontWeight="semibold">{props.title || "Are you sure?"}</PopoverHeader>
              <PopoverArrow />
              <PopoverCloseButton />
              {props.text && (
                <PopoverBody>
                  <Text>{props.text}</Text>
                </PopoverBody>
              )}
              <PopoverFooter border={0} display="flex" justifyContent="flex-end">
                <ButtonGroup size="sm">
                  <Button variant="outline" onClick={onClose}>
                    Annuleren
                  </Button>
                  <Button
                    colorScheme={props.submitColor || "pink"}
                    onClick={props.onSubmit}
                    isLoading={props.isLoading}
                  >
                    {props.submitText || "Bevestigen"}
                  </Button>
                </ButtonGroup>
              </PopoverFooter>
            </PopoverContent>
          </Portal>
        </>
      )}
    </Popover>
  )
}
